import { parseISO } from "date-fns";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useCurrentUser } from "modules/auth";

import {
  fetchLicenceAgreementFile,
  fetchLicenceAgreementLastUpdate,
  selectLicenceAgreement,
} from "../store";

export function useTermsAndConditions() {
  const dispatch = useDispatch();

  const licenceAgreement = useSelector(selectLicenceAgreement);
  const { lastUpdate, file } = licenceAgreement;
  const { currentUser } = useCurrentUser();

  const lastUpdateDate = lastUpdate ? parseISO(lastUpdate?.date) : null;

  const userTermsAndConditionsAcceptanceDate = currentUser?.metadata
    ?.termsAcceptanceDate
    ? parseISO(currentUser.metadata.termsAcceptanceDate)
    : null;

  const doesUserNeedToAcceptTermsAndConditions =
    userTermsAndConditionsAcceptanceDate && lastUpdateDate
      ? userTermsAndConditionsAcceptanceDate < lastUpdateDate
      : true;

  useEffect(() => {
    if (!lastUpdate) {
      dispatch(fetchLicenceAgreementLastUpdate());
    } else if (!file) {
      dispatch(fetchLicenceAgreementFile({ version: lastUpdate.version }));
    }
  }, [dispatch, lastUpdate, file]);

  return {
    licenceAgreement,
    doesUserNeedToAcceptTermsAndConditions,
  };
}
